import { CampaignAnalysis } from "features/attributionAnalytics";

function AdPerformanceAnalysisPage() {
  return <CampaignAnalysis />;
}

export default AdPerformanceAnalysisPage;
